import type { SiteConfig } from '@/types'
import { getOrigin } from '@/lib/window'

export const siteConfig: SiteConfig = {
    name: 'Chalkline',
    description: 'Live video classes for one educator and up to 50 learners, with a shared whiteboard, slides, raised hands, live notes, recordings and class reminders.',
    placeholder: '',
    url: getOrigin(),
    ogImage: '/images/teacher-dual-setup.jpg'
}

export const LEARNER_LIMIT = 50
